<template>
	<div class="congratulations">
		<div class="title">{{ t('workbooks.success_modal.congratulations') }}</div>

		<div class="body">
			<i18n-t keypath="workbooks.success_modal.download_link" />
			<div v-if="isApplePrivaterelayEmail">
				<i18n-t keypath="workbooks.success_modal.privaterelay_email" />
			</div>
			<b v-else>{{ email }}</b>
		</div>

		<a @click.prevent="$emit('close')" href="" class="btn btn-primary btn-block">{{
			t('workbooks.success_modal.ok')
		}}</a>
	</div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { computed } from '@vue/reactivity'

export default {
	props: ['email'],

	setup(props) {
		const { t } = useI18n()
		const isApplePrivaterelayEmail = computed(() => {
			try {
				const [, f] = props.email.split('@')
				return f.includes('privaterelay.appleid.com')
			} catch (e) {
				console.error(e)
				return false
			}
		})

		return {
			t,
			isApplePrivaterelayEmail
		}
	}
}
</script>

<style lang="scss" scoped>
.title {
	text-align: center;
	font-weight: bold;
	font-size: 2rem;
}

.body {
	margin-top: 20px;
	text-align: center;
	font-size: 1.1rem;

	b {
		display: block;
		margin-top: 15px;
		word-wrap: break-word;
		line-height: 1.4;
	}
}

.btn {
	margin-top: 30px;
}
</style>
